import { parseMcleodDate } from "../utils/dateHelpers";

export default class LocationSerializer {
  static serialize(data) {
    return {
      ...data
    };
  }

  static deSerialize(data) {
    return {
      ...data,
      mondayOpen: parseMcleodDate(data.monday_open),
      mondayClose: parseMcleodDate(data.monday_close),
      tuesdayOpen: parseMcleodDate(data.tuesday_open),
      tuesdayClose: parseMcleodDate(data.tuesday_close),
      wednesdayOpen: parseMcleodDate(data.wednesday_open),
      wednesdayClose: parseMcleodDate(data.wednesday_close),
      thursdayOpen: parseMcleodDate(data.thursday_open),
      thursdayClose: parseMcleodDate(data.thursday_close),
      fridayOpen: parseMcleodDate(data.friday_open),
      fridayClose: parseMcleodDate(data.friday_close),
      saturdayOpen: parseMcleodDate(data.saturday_open),
      saturdayClose: parseMcleodDate(data.saturday_close),
      sundayOpen: parseMcleodDate(data.sunday_open),
      sundayClose: parseMcleodDate(data.sunday_close),
    };
  }
}